/*
	Dimension by HTML5 UP
	html5up.net | @ajlkn
	Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
*/ function $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17(message, type = 'success') {
    const toast = document.getElementById('toast');
    // Remove any previous type classes
    toast.classList.remove('bg-green-800', 'bg-red-800', 'hidden', 'opacity-0', 'translate-x-10');
    // Set new styles based on type
    if (type === 'success') toast.classList.add('bg-green-800');
    else if (type === 'error') toast.classList.add('bg-red-800');
    toast.textContent = message;
    // Show with transition
    toast.classList.remove('opacity-0', 'translate-x-10');
    toast.classList.add('opacity-100', 'translate-x-0');
    // Display it
    toast.classList.remove('hidden');
    // Hide after 4 seconds
    setTimeout(()=>{
        toast.classList.add('opacity-0', 'translate-x-10');
        toast.classList.remove('opacity-100');
        setTimeout(()=>{
            toast.classList.add('hidden');
        }, 500); // match transition duration
    }, 4000);
}


const $22b6d1a10df0be46$var$TIMEOUT_AFTER_SUBMIT = 5000; // 5 seconds
const $22b6d1a10df0be46$var$ERROR_MESSAGE = "Oops! There was a problem submitting your message";
function $22b6d1a10df0be46$var$handleSuccess(form) {
    (0, $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17)("Thanks for your submission!", "success");
    form.reset();
    const submitButton = document.getElementById("contact-submit-button");
    // Disable the button
    submitButton.disabled = true;
    setTimeout(()=>{
        // Re-enable the button after 5 seconds
        submitButton.disabled = false;
    }, $22b6d1a10df0be46$var$TIMEOUT_AFTER_SUBMIT);
}
async function $22b6d1a10df0be46$export$89c2621768820c8b(event) {
    event.preventDefault();
    var formData = new FormData(event.target);
    var data = Object.fromEntries(formData.entries());
    const { name: name, email: email, message: message } = data;
    if (!name || !email || !message) {
        (0, $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17)("Please fill in all fields", "error");
        return;
    }
    fetch(event.target.action, {
        method: event.target.method,
        body: JSON.stringify(data),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response)=>{
        if (response.ok) $22b6d1a10df0be46$var$handleSuccess(event.target);
        else response.json().then((data)=>{
            if (Object.hasOwn(data, 'errors')) (0, $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17)(data["errors"].map((error)=>error["message"]).join(", "), "error");
            else {
                (0, $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17)($22b6d1a10df0be46$var$ERROR_MESSAGE, "error");
                console.error('There was a problem with your fetch operation:', data);
            }
        });
    }).catch((error)=>{
        (0, $29e2a4ad705b06a9$export$f6cef6fcf9ca4e17)($22b6d1a10df0be46$var$ERROR_MESSAGE, "error");
        console.error('There was a problem with your fetch operation:', error);
    });
}


(function($) {
    var $window = $(window), $body = $('body'), $wrapper = $('#wrapper'), $header = $('#header'), $footer = $('#footer'), $main = $('#main'), $main_articles = $main.children('article');
    // Play initial animations on page load.
    $window.on('load', function() {
        window.setTimeout(function() {
            $body.removeClass('is-preload');
        }, 100);
    });
    // Nav.
    var $nav = $header.children('nav'), $nav_li = $nav.find('li');
    // Add "middle" alignment classes if we're dealing with an even number of items.
    if ($nav_li.length % 2 == 0) {
        $nav.addClass('use-middle');
        $nav_li.eq($nav_li.length / 2).addClass('is-middle');
    }
    // Main.
    var delay = 325, locked = false;
    // Methods.
    $main._show = function(id, initial) {
        var $article = $main_articles.filter('#' + id);
        // No such article? Bail.
        if ($article.length == 0) return;
        // Handle lock.
        // Already locked? Speed through "show" steps w/o delays.
        if (locked || typeof initial != 'undefined' && initial === true) {
            // Mark as switching.
            $body.addClass('is-switching');
            // Mark as visible.
            $body.addClass('is-article-visible');
            // Deactivate all articles (just in case one's already active).
            $main_articles.removeClass('active');
            // Hide header, footer.
            $header.hide();
            $footer.hide();
            // Show main, article.
            $main.show();
            $article.show();
            // Activate article.
            $article.addClass('active');
            // Unlock.
            locked = false;
            // Unmark as switching.
            setTimeout(function() {
                $body.removeClass('is-switching');
            }, initial ? 1000 : 0);
            return;
        }
        // Lock.
        locked = true;
        // Article already visible? Just swap articles.
        if ($body.hasClass('is-article-visible')) {
            // Deactivate current article.
            var $currentArticle = $main_articles.filter('.active');
            $currentArticle.removeClass('active');
            // Show article.
            setTimeout(function() {
                // Hide current article.
                $currentArticle.hide();
                // Show article.
                $article.show();
                // Activate article.
                setTimeout(function() {
                    $article.addClass('active');
                    // Window stuff.
                    $window.scrollTop(0).triggerHandler('resize.flexbox-fix');
                    // Unlock.
                    setTimeout(function() {
                        locked = false;
                    }, delay);
                }, 25);
            }, delay);
        } else {
            // Mark as visible.
            $body.addClass('is-article-visible');
            // Show article.
            setTimeout(function() {
                // Hide header, footer.
                $header.hide();
                $footer.hide();
                // Show main, article.
                $main.show();
                $article.show();
                // Activate article.
                setTimeout(function() {
                    $article.addClass('active');
                    // Window stuff.
                    $window.scrollTop(0).triggerHandler('resize.flexbox-fix');
                    // Unlock.
                    setTimeout(function() {
                        locked = false;
                    }, delay);
                }, 25);
            }, delay);
        }
    };
    $main._hide = function(addState) {
        var $article = $main_articles.filter('.active');
        // Article not visible? Bail.
        if (!$body.hasClass('is-article-visible')) return;
        // Add state?
        if (typeof addState != 'undefined' && addState === true) history.pushState(null, null, '#');
        // Handle lock.
        // Already locked? Speed through "hide" steps w/o delays.
        if (locked) {
            // Mark as switching.
            $body.addClass('is-switching');
            // Deactivate article.
            $article.removeClass('active');
            // Hide article, main.
            $article.hide();
            $main.hide();
            // Show footer, header.
            $footer.show();
            $header.show();
            // Unmark as visible.
            $body.removeClass('is-article-visible');
            // Unlock.
            locked = false;
            // Unmark as switching.
            $body.removeClass('is-switching');
            // Window stuff.
            $window.scrollTop(0).triggerHandler('resize.flexbox-fix');
            return;
        }
        // Lock.
        locked = true;
        // Deactivate article.
        $article.removeClass('active');
        // Hide article.
        setTimeout(function() {
            // Hide article, main.
            $article.hide();
            $main.hide();
            // Show footer, header.
            $footer.show();
            $header.show();
            // Unmark as visible.
            setTimeout(function() {
                $body.removeClass('is-article-visible');
                // Window stuff.
                $window.scrollTop(0).triggerHandler('resize.flexbox-fix');
                // Unlock.
                setTimeout(function() {
                    locked = false;
                }, delay);
            }, 25);
        }, delay);
    };
    // Articles.
    $main_articles.each(function() {
        var $this = $(this);
        // Close.
        $('<div class="close">Close</div>').appendTo($this).on('click', function() {
            location.hash = '';
        });
        // Prevent clicks from inside article from bubbling.
        $this.on('click', function(event) {
            event.stopPropagation();
        });
    });
    // Events.
    $body.on('click', function(event) {
        // Article visible? Hide.
        if ($body.hasClass('is-article-visible')) $main._hide(true);
    });
    $window.on('keyup', function(event) {
        switch(event.keyCode){
            case 27:
                // Article visible? Hide.
                if ($body.hasClass('is-article-visible')) $main._hide(true);
                break;
            default:
                break;
        }
    });
    $window.on('hashchange', function(event) {
        // Empty hash?
        if (location.hash == '' || location.hash == '#') {
            // Prevent default.
            event.preventDefault();
            event.stopPropagation();
            // Hide.
            $main._hide();
        } else if ($main_articles.filter(location.hash).length > 0) {
            // Prevent default.
            event.preventDefault();
            event.stopPropagation();
            // Show article.
            $main._show(location.hash.substr(1));
        }
    });
    // Scroll restoration.
    // This prevents the page from scrolling back to the top on a hashchange.
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    else {
        var oldScrollPos = 0, scrollPos = 0, $htmlbody = $('html,body');
        $window.on('scroll', function() {
            oldScrollPos = scrollPos;
            scrollPos = $htmlbody.scrollTop();
        }).on('hashchange', function() {
            $window.scrollTop(oldScrollPos);
        });
    }
    // Initialize.
    // Hide main, articles.
    $main.hide();
    $main_articles.hide();
    // Initial article.
    if (location.hash != '' && location.hash != '#') $window.on('load', function() {
        $main._show(location.hash.substr(1), true);
    });
    // Contact form
    document.getElementById("contact-form").addEventListener("submit", (0, $22b6d1a10df0be46$export$89c2621768820c8b));
})(jQuery);


//# sourceMappingURL=webapp.1154c035.js.map
